import { TypeOfAttachment } from 'owa-addins-core';
import { AttachmentFileType } from 'owa-attachment-common';
import { getExtensionFromFileName } from 'owa-file-common';
export default function createAttachmentFiles(attachments) {
    var attachmentFiles = [];
    for (var _i = 0, attachments_1 = attachments; _i < attachments_1.length; _i++) {
        var attachment = attachments_1[_i];
        var file = null;
        if (attachment.attachmentType == TypeOfAttachment.Item) {
            file = {
                fileType: AttachmentFileType.MailItem,
                name: attachment.name,
                size: attachment.size,
                itemId: attachment.id,
            };
        }
        else if (attachment.attachmentType == TypeOfAttachment.File) {
            file = {
                fileType: AttachmentFileType.Uri,
                name: attachment.name,
                size: attachment.size,
                uri: attachment.id,
                type: getExtensionFromFileName(attachment.id),
            };
        }
        if (file) {
            attachmentFiles.push({ file: file, isInline: attachment.isInline });
        }
    }
    return attachmentFiles;
}
//# sourceMappingURL=createAttachmentFiles.js.map